module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d7e2"
    }
  }, [_vm._v("Introduction ")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e8838"
    }
  }, [_c('i', [_vm._v("The world is a ")]), _c('br'), _c('i', [_vm._v("frightening place.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e8938"
    }
  }, [_vm._v("But you already knew that; you read it in the paper, hear about it from friends, see it with your own eyes every time you turn on the TV to watch bad singers or dancers subject themselves to abuse from judges with no more talent than the contestants, or see a web video of a teenager shooting a bottle rocket from his ass for amusement, or get plowed from behind in your car by another driver who was texting “LMAO” to his friends instead of noticing that the light had turned red and you had stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9278"
    }
  }, [_vm._v("If random violence doesn’t get you, cancer will. If cancer doesn’t, global warming will. If global warming doesn’t, bullet ants will. Or botflies. Or lightning. Or tsunamis. Or the Great Pacific Garbage Patch. Or Fijian headhunters. Or just normal everyday activities like drinking water, eating an orange, breathing the air, or having sex with a goat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9508"
    }
  }, [_vm._v("Yes, we are in deep doo-doo. You should be scared to death, right?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9668"
    }
  }, [_vm._v("Wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9738"
    }
  }, [_vm._v("Okay, sure, this is a book of scary facts, and the more you read, the more afraid you are likely to be. I wouldn’t be doing my job if you weren’t. But if forewarned is forearmed, then the more you know, the safer you’ll feel, even if it’s a false sense of security since you can’t do a thing about most of what you read here. But who cares, as long as you feel better?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10049"
    }
  }, [_vm._v("If not—if this information scares the shit out of you—that’s okay, too. You’re probably reading this on the crapper, anyway, and what better place to be scared shitless? Isn’t that the idea, to be shitless? At least you aren’t befouling a nice pair of pants. I’m also keeping you regular. You’re welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10349"
    }
  }, [_vm._v("While I’m scaring you, though, I also hope to make you laugh. There’s a joke after every fact, for chrissakes. Do you have any idea how hard it is to make jokes about things like a guy getting the wrong testicle removed during surgery? Okay, bad example. But you get the idea: you should laugh when you read this book. If you don’t, either you have no sense of humor or I need a new career. I’m too old to start a new career, so the blame falls squarely on you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10659"
    }
  }, [_vm._v("Be warned also that you might be offended by this book when I make fun of someone or something you love. Butts of my jokes include doctors, dentists, Latvians, Texans, kids, pets, Deadheads, mothers-in-law, Death Row inmates, Catholics, Pentecostals, Sammy Hagar, Lyle Lovett, the French, Tennessee, fast-food employees, and numerous other people, places and things. I also make ample fun of myself, my wife, my (fictitious) sex life, my home state of Georgia, and other things I hold near and dear. So unbunch your panties and laugh a little. Even you, Sammy Hagar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e11039"
    }
  }, [_vm._v("Far more offensive than my jokes are the ridiculous things that occur in this world on a daily basis, so read these facts and be afraid, be amused, be annoyed, be aghast, be whatever. You already bought the book and I already got paid, so I don’t really care. Sorry, just being honest. (Sort of.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e11229"
    }
  }, [_vm._v("And remember: front to back, and keep wiping until the TP is clean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e11279"
    }
  }, [_vm._v("Your pal,")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e11339"
    }
  }, [_c('i', [_vm._v("Cary McNeal ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0685fc39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/McNe_9781605506241_epub_c8_r1.vue
// module id = 75
// module chunks = 0